import {
  FormControlLabel,
  FormControlLabelProps,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";

import { SelectionProperty } from "types";

interface Props
  extends Omit<
    FormControlLabelProps,
    "label" | "control" | "property" | "onChange"
  > {
  property: SelectionProperty;
  onChange: (value: SelectionProperty) => void;
}

export function LayerPropertyDropdown(props: Props) {
  const { property, onChange, ...rest } = props;

  function onDropdownChange(event: SelectChangeEvent<number>) {
    const { value } = event.target;
    const matchedValue = property.values.find((val) => {
      return val.id === value;
    });

    if (matchedValue) onChange({ ...property, value: matchedValue });
  }

  return (
    <Styles
      {...rest}
      labelPlacement="start"
      control={
        <Select<number> value={property.value.id} onChange={onDropdownChange}>
          {property &&
            property.values.map((value) => (
              <MenuItem key={value.id} value={value.id}>
                {value.name}
              </MenuItem>
            ))}
        </Select>
      }
      label={property.label || ""}
    />
  );
}

const Styles = styled(FormControlLabel)`
  margin: 0;
  border-right: 1px solid ${({ theme }) => theme.palette.grey[700]};

  .MuiOutlinedInput-root {
    .MuiSvgIcon-root {
      transform: translateY(${({ theme }) => theme.spacing(-0.3)});
    }
    .MuiOutlinedInput-notchedOutline {
      border: 0;
      border-width: 0;
    }
  }

  & > .MuiTypography-root {
    text-transform: uppercase;
    font-weight: 700;
    margin-right: ${({ theme }) => theme.spacing(1)};
  }
`;
